import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { UserService } from './../../service/user.service'

const AddUser = (params) => {
    const [users, setUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedUsers, setsSelectedUsers] = useState([]);
    const userService = new UserService();

    useEffect(() => {
        const fetchData = async () => {
            const result = await userService.getUsers();
            setAllUsers(result.data);

            let userData = result.data.map(function (a) {
                return {value: a.id, label: (a.firstName + " " + a.lastName)};
            });
            setUsers(userData);
        }

        fetchData()
            .catch(console.error);
    }, []);

    const onSuccess = () => {
        let ids = selectedUsers.map(function (a) {
            return a.value;
        });
                
        let selUsers = allUsers.filter((x) => {
            return ids.includes(x.id);
        }).map(function (a) {
            return { id: a.id, name: (a.firstName + " " + a.lastName), email: a.email };
        });

        params.callBack(selUsers);
        params.onClose();
    };
    
    return (
        <div className="card" style={{ maxWidth: "500px", minWidth: "350px" }}>
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Add User
            </h5>
            <div className="card-body">
                <div className="ag-theme-alpine">
                    <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                        <div>
                            <label>Users</label>
                            <Select options={users} value={selectedUsers} isMulti onChange={(e) => setsSelectedUsers(e)}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer text-muted">
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-secondary" onClick={onSuccess}>Add</button>
                    <button style={{ marginLeft: "5px" }} className="btn btn-secondary" onClick={params.onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default AddUser;